import type {
    Observer,
    Subject
} from '@naturehouse/nh-essentials/lib/architecture/ObserverPattern';
import FlexibleArrivalDateFilter from '../store/FlexibleArrivalDateFilter';
import HouseSearchFilters from '../store/HouseSearchFilters';

export default class FlexibleArrivalDateConnector implements Observer {
    readonly #element: HTMLInputElement;

    readonly #filter: FlexibleArrivalDateFilter;

    constructor(element: HTMLInputElement, filter: FlexibleArrivalDateFilter) {
        this.#element = element;
        this.#filter = filter;

        this.#element.addEventListener('change', this.#updateFilter.bind(this));
    }

    update(subject: Subject): void {
        if (!(subject instanceof FlexibleArrivalDateFilter)) return;

        this.#element.value = subject.parameters.flexibleArrivalDate || '0';
    }

    #updateFilter(): void {
        this.#filter.flexibleRange = Number(this.#element.value || '0');
    }

    public static connectToElement(querySelector: string): void {
        const filters = HouseSearchFilters.getInstance();
        const element = document.querySelector(querySelector) as HTMLInputElement | null;
        const filter = filters.get(FlexibleArrivalDateFilter.NAME) as
            | FlexibleArrivalDateFilter
            | undefined;

        if (!element || !filter) return;

        const connector = new FlexibleArrivalDateConnector(element, filter);
        filter.attach(connector);
    }
}
